// @refresh reset

import {extendConfig} from './extend-config';

export const config = extendConfig({
  datadog: {
    environment: `local`,
    enabled: true,
    sessionSampleRate: 0,
    sessionReplaySampleRate: 0,
  },
  flags: {
    common: {
      enableLogs: false,
    },
  },
  api: {
    shouldMock: false,
  },
  logs: {
    enabled: true,
    level: `debug`,
    browser: {
      enabled: true,
      level: process.env.NEXT_PUBLIC_LOG_LEVEL || `debug`,
    },
  },
});
